export const API_URL = (import.meta.env.VITE_API_URL ?? "https://api.tank.chat").replace(/\/$/, "");
export const WS_URL = (import.meta.env.VITE_WS_URL ?? "wss://gw.tank.chat").replace(/\/$/, "");

/**
 * Production builds ride the `tank_sid` cookie the api sets for `Domain=tank.chat`.
 * Dev builds run on localhost, where that cookie never arrives, so they use the
 * bearer tokens CompleteMagicLink also returns.
 */
export const AUTH_MODE: "cookie" | "bearer" = import.meta.env.DEV ? "bearer" : "cookie";
